export const ZIPCODE_NOT_FOUND_ERROR_CODE = 'PSTL_ERR_001';
export const INVALID_PAYMENT_ERROR_CODES = {
    PYMTCRD_ERR_108: 'PYMTCRD_ERR_108',
    PYMTCRD_ERR_109: 'PYMTCRD_ERR_109',
    PYMTCRD_ERR_140: 'PYMTCRD_ERR_140',
    PYMTCRD_ERR_159: 'PYMTCRD_ERR_159',
    PYMTCRD_ERR_127: 'PYMTCRD_ERR_127',
    PAYMENT_ERR_500: 'PAYMENT_ERR_500',
    PYMTCRD_ERR_197: 'PYMTCRD_ERR_197',
    PYMTCRD_ERR_202: 'PYMTCRD_ERR_202',
    PYMTCRD_ERR_203: 'PYMTCRD_ERR_203',
    PYMTCRD_ERR_204: 'PYMTCRD_ERR_204',
    PYMTCRD_ERR_218: 'PYMTCRD_ERR_218',
    PYMTCRD_ERR_252: 'PYMTCRD_ERR_252',
};
export const INVALID_ADD_CARD_ERROR_CODES = {
    PYMTCRD_ERR_279: 'PYMTCRD_ERR_279',
    PYMTCRD_ERR_290: 'PYMTCRD_ERR_290',
    PYMTCRD_ERR_280: 'PYMTCRD_ERR_280',
    PYMTCRD_ERR_281: 'PYMTCRD_ERR_281',
    PYMTCRD_ERR_291: 'PYMTCRD_ERR_291',
    PYMTCRD_ERR_292: 'PYMTCRD_ERR_292',
};
export const MAX_T2C_TENDER_LIMIT_REACHED_CODE = 'PYMTCRD_ERR_189';
export const T2C_NUMBER_ASSOCIATED_ANOTHER_ACCOUNT = 'PYMTCRD_ERR_188';
export const PUBLIC_KEY_RETRIEVAL_FAILED = 'PUBLIC_KEY_RETRIEVAL_FAILED';
